import React from "react";

function About() {
  return (
    <div className="py-10 xl:px-32 lg:px-24 md:px-16 px-10 ">
      <h2 className="text-center underline xl:text-4xl lg:text-3xl md:text-2xl text-xl font-semibold pb-5">
        About Us
      </h2>
      <div className="flex justify-between py-5 w-full flex-col md:flex-row">
        <div className="md:w-[40vw] w-full pr-6">
          <small className="text-lg">
            Where Design Flourishes on Printed Canvas
          </small>
          <h1 className="text-3xl font-medium py-4">Keyline Solution</h1>
          <p className="pb-4 opacity-70">
            We are a digital, litho and large format printers in Nottingham. We
            offer high quality digital printing, litho printing, large format
            printing and a free design service that has never been seen before.
            Feel free to browse our site and if you find any print prices that
            compare with our listings, please contact us and we will do our best
            to compete!{" "}
          </p>
          <p className="pb-4 opacity-75">
            Please Note: Our 24 hour courier service is for orders approved for
            printing before 9am the day prior to delivery. The service is
            available next working day only (Monday-Friday) and not available
            for weekends or bank holidays. This is not a guaranteed service
            especially during busy periods like Christmas and bank holidays.
          </p>
        </div>
        <div className="h-[60vh] md:w-[40vw] w-full ">
          <img
            src="https://plus.unsplash.com/premium_photo-1683121596697-c423f23e1c1e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fHByaW50aW5nJTIwcHJlc3N8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
            alt=""
            srcset=""
            className="object-cover object-top h-full w-full"
          />
        </div>
      </div>
    </div>
  );
}

export default About;
